import script from "./CustomDataFieldPickerModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomDataFieldPickerModal.vue?vue&type=script&setup=true&lang=js"

import "./CustomDataFieldPickerModal.vue?vue&type=style&index=0&id=3dcdb563&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dcdb563"]])

export default __exports__